import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { AutoCarousel } from "@components/media/AutoCarousel"
import { LargeCard } from "@components/patterns/LargeCard"
import { Chip } from "@components/ui/Chip"
import { StrandTileFragment } from "@generated-types"
import { useBreakpointChange } from "@hooks/useBreakpoint"
import { Link } from "eddev/routing"
import { useState } from "react"

type Props = { strand: StrandTileFragment; direction?: "left" | "right" }

export function LargeStrandTile(props: Props) {
  const strand = props.strand
  const [hovering, setHovering] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useBreakpointChange((bp) => {
    if (bp === "BASE" || bp === "sm") {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  })

  return (
    <Link href={strand?.uri!} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
      <LargeCard
        theme="grey"
        title={<div className="type-title-l">{strand?.title}</div>}
        description={
          <div className="h-[5em] line-clamp-3 md:h-auto" dangerouslySetInnerHTML={{ __html: strand?.excerpt! }} />
        }
        media={
          <div className="w-[30vw] md:w-auto aspect-video md:aspect-auto bg-black md:absolute md:inset-0">
            <AutoCarousel
              aspect={16 / 9}
              direction={props.direction}
              speed={isMobile ? 0.1 : hovering ? 0.6 : 0.1}
              items={
                strand?.images?.map((img) => (
                  <div className="flex pr-3 h-full">
                    <ResponsiveImage srcSet={img.srcSet} objectFit="cover" className="w-full h-full" />
                  </div>
                ))!
              }
            />
          </div>
        }
        animationKey={strand?.uri!}
        layout="row"
        infoWidth="lg"
        height="sm"
        tags={[
          // <Chip variant="primary">Program Strand</Chip>,
          strand?.info?.category?.name && <Chip variant="inverted">{strand?.info?.category?.name}</Chip>,
          <Chip variant="inverted">{strand.totalFilms} Films</Chip>,
        ]}
      />
    </Link>
  )
}
